import ListItem from '@klv/molecules/bulleted-list-item';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/bulletedListColumn.module.scss';

import type { IBulletedList } from './types';

const BulletedListColumn = ({
  bulletedListItems,
  bulletType,
  className,
  listBodyCopy,
  listHeadline,
  headlineTag = 'h2',
  colorVariant = 'dark',
  showBullets = false,
  ...rest
}: IBulletedList) => {
  const HeadlineTag = headlineTag;

  return (
    <div className={generateClassName(['bulletedListColumn', className, styles[colorVariant], styles.wrapper])} {...rest}>
      {(listHeadline || listBodyCopy) && (
      <div className={styles.introText}>
        {listHeadline && (
          <HeadlineTag className={generateClassName(['h5', 'semibold'])}>{listHeadline}</HeadlineTag>
        )}
        {listBodyCopy && (
          <div className={generateClassName(['p2'])} dangerouslySetInnerHTML={{ __html: listBodyCopy }} />
        )}
      </div>
      )}
      <ul className={styles.list} role="list">
        {bulletedListItems.map((item) => (
          <ListItem
            bulletType={showBullets ? bulletType : undefined}
            colorVariant={colorVariant}
            itemCopy={item.bulletedListItem.itemCopy}
            itemHeading={item.bulletedListItem.itemHeading}
            itemLink={item.bulletedListItem.itemLink}
            itemNewWindow={item.bulletedListItem.itemNewWindow}
            key={JSON.stringify(item)}
          />
        ))}
      </ul>
    </div>
  );
};

export default BulletedListColumn;
